import { FilterOps } from '@@types'

import { useFetchShopProducts } from '@entities/Product'

import { useAddressStore } from '@features/shipping-methods'

import { ProductCarousel } from '@widgets/product-carousel'

export type ProductListInfo = {
  mode: 'group' | 'ids'
  xids: string[]
  productGroupId?: string
  title?: string
}

type ProductListProps = {
  data: ProductListInfo
  className?: string
}


export default function ProductList ({
  data,
  className
}: ProductListProps) {
  const { shopId } = useAddressStore()

  const { products, loading } = useFetchShopProducts({
    shopId,
    filter: {
      or: [
        {
          fields: [ 'productGroupIds' ],
          op: FilterOps.EQUAL,
          value: data.productGroupId
        },
        {
          fields: [ 'xid' ],
          op: FilterOps.CONTAINS,
          value: data.xids,
        },
      ],
    },
    page: 1,
    limit: data.xids?.length || 12,
    sort: { fieldName: 'new', direction: 1 },
  })


  return (
    <div className={className}>
      <ProductCarousel
        title={data.title}
        products={products || []}
        loading={loading}
      />
    </div>
  )
}
